<template>
  <div :class="PanelClass" v-show="isActive">

    <div class="payitemavailable " > <!-- v-show="priorValid" -->
    
      <addpayment buttonClass='btn cashpaymentbutton' name="Cash" :defaultAmount="due" @save="addPayItem" @opendrawer="OpenDrawer" 
            v-if="showCash" :disabled="disablePayments"/>
      <addpayment buttonClass='btn paymentbutton' name="Check" :defaultAmount="due" @save="addPayItem" :isCheck="paramTrue" :numberDataLabel="checkNumberDataLabel" 
            v-if="showCheck" :allowOverAvailableAmount="allowPaymentOverDue" :availableAmount="due" :disabled="disablePayments"/>
      
      <addpayment buttonClass='btn paymentbutton' name="Card" :defaultAmount="due" @save="addPayItem" :numberDataLabel="cardNumberDataLabel" 
            v-if="showBankcard" :allowOverAvailableAmount="allowPaymentOverDue" :availableAmount="due" :disabled="disablePayments"/>
       <addpayment buttonClass='btn paymentbutton' :name="accountBalanceLabel" :defaultAmount="due" @save="addPayItem" 
            v-if="showAccount" :allowOverAvailableAmount="allowPaymentOverDue" :availableAmount="due" :disabled="disablePayments || accountBalanceLabel=='No Account Available'"/>
       <addpayment_ar buttonClass='btn paymentbutton' :name="arLabel" :defaultAmount="due" @save="addPayItem_ar"   
            v-if="showAR"  :subtypeList="arPaymentItemSubtypes" :disabled="disablePayments"/>
       <addpayment buttonClass='btn paymentbutton' :name="faBalanceLabel" :defaultAmount="fadefaultpay" @save="addPayItem" 
          v-if="showFA" :allowOverAvailableAmount="paramFalse" :availableAmount="faBalance" :disabled="disableFA || disablePayments"/>
       <addpayment buttonClass='btn paymentbutton' name="Gift Certificate" :defaultAmount="due" @save="addPayItem" 
          v-if="showGiftCertificate" :allowOverAvailableAmount="allowPaymentOverDue" :availableAmount="due" :numberDataLabel="certNumberDataLabel" :disabled="disablePayments"/>
       <addpayment_gift buttonClass="btn paymentbutton" name="Gift Card" :defaultAmount="due" @save="addPayItem" 
          v-if="showGiftcard" :disabled="disablePayments"/>
      
      <!-- <addpayment buttonClass='btn paymentbutton' name="Other" :defaultAmount="due" @save="addPayItem"/> -->
      <div class="allpmt">
        <button class='btn paymentbutton' @click="addPayItemAccountAll" v-if="showAccountShortcut" :disabled="disablePayments">{{accountAllLabel}}</button>
      </div>
    </div>
    <div class="payitemadded ">
      <label class="eligiblemessage" v-if="cartEligibleForFA">*All items in Cart Eligible For Financial Aid*</label>
      <label for class="text subtitle">Payments</label>
      <payitem v-for="payItem in payItems" v-bind:key="payItem.id" v-bind:payItem="payItem"  @removeitem="removepayitem" />
      <label for class="text text-right totaltext">Payment Total: {{ payTotal|toCurrency }}</label>
      <label for class="text text-right totaltext paycolor">Due: {{ due|toCurrency }}</label>
      <label for class="text text-right totaltext paycolor">Change: {{ change|toCurrency }}</label>
      <div v-show="isValid && zeroDue">
        <!-- <button class="btn actionbutton narrowbutton"  @click="getReceiptData" v-if="receiptPrinterType=='ip'" >Receipt</button> -->
        <button class="btn actionbutton narrowbutton"  @click="receiptOnNewPage" v-if="receiptPrinterType=='newpage'" >Print Receipt</button>
        <button ref="printthereceipt" class="btn actionbutton narrowbutton"  v-print="'#receiptdatadiv'" v-show="false">Print Receipt</button>

        <!-- this is teh receipt options button if NOT auto -->
        <button class="btn actionbutton "   v-if="!autoReceiptAfterProcess" @click="popOptions()" >Print Receipt</button>
        <receiptoptions ref="receiptoptions" @close="completeIfAuto" />
      <!-- :showButton="!autoReceiptAfterProcess" -->

        <!-- <button ref="drawer" class="btn actionbutton narrowbutton"  v-print="'#drawerdiv'" >drawer</button> -->
        <!-- <div  class="receiptclass" id="receiptdatadiv" v-if="receiptData!=null && receiptIP=='laser'" >
          <label>{{receiptData}}</label>
        </div> -->
      </div>
      
    </div>


    <div class="nextbutton">
     
      <div class="nextbutton">
        <label class="pleasewait" v-if="inPayment">Processing, please wait...</label>
      </div>
      
        
      <button @click="startKeyedEntry()" class="btn actionbutton" v-if="showKeyedEntryButton && inPayment && usingGeniusTerminal">Keyed Card Entry</button>
      <button @click="startCancelEntry()" class="btn actionbutton" v-if="showKeyedEntryButton && inPayment && usingGeniusTerminal">Cancel Card Entry</button>
      <div v-if="showPayMultCard && !inPayment">
        <button v-for="payItem in payItems_unprocessedCardOnly" v-bind:key="payItem.id"   class="btn actionbutton" 
            @click="process_terminaltest_single(payItem)" >{{ processbuttontext(payItem) }}</button>
      </div>
      
         
        <button class="btn actionbutton" @click="process_terminaltest" v-show="isValid && zeroDue && !showPayMultCard && !inPayment" :disabled="pleaseWait">{{completeText}}</button>
      
     
        <!-- <a href="file:///c:/senddatv120/test.bat">test</a> -->
        <!-- <button class="btn actionbutton"  @click="OpenDrawer">Open Drawer</button> -->
        <div hidden>
          <div  class="receiptclass" id="receiptdatadiv" v-if="receiptData!=null" >
            <label>{{receiptData}}</label>
          </div>
        </div>
        
        <div id="drawerdiv">
          <label class="drawerfont"></label>
        </div>
        <confirmrefundreturn ref="refundreason"  :showButton="paramFalse"  body="Please select a reason for the refund" title="Refund Reason" @savereason="saveInventoryActionReason" />   
               
    </div>
 
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import payitem from '../actions/payitem.vue'
import format from '../../style/format.js'
import addpayment from '../actions/addpayment.vue'
import addpayment_gift from '../actions/addpayment_gift.vue'
import addpayment_ar  from '../actions/addpayment_ar.vue'
import print from 'vue-print-nb'
import pay from '../../services/pay.js'
import pos from '../../services/pos.js'
import confirmrefundreturn from '../actions/confirmrefundreturn.vue'
import receiptoptions from '../actions/receiptoptions.vue'
export default {
  data() {
    return {
      paramTrue:true,
      paramFalse:false,

    };
  },
  directives:{
    print
  },
  components:{
    payitem,
    addpayment,
    addpayment_gift,
    addpayment_ar,
    confirmrefundreturn,
    receiptoptions


  },
  mixins:[format,pay,pos],
  props: ["panelIndex"],
  computed: {
    ...mapFields([
            
        ]),
        
    
    isActive: function() {
      return this.panels[this.panelIndex].active;
    },
    isValid: function() {
      return this.panels[this.panelIndex].valid;
    },
    
    priorValid: function() {
      return this.panels[this.panelIndex - 1].valid;
    },
    
    PanelClass: function() {
      var classes = "panel-full panel payfull ";
      if (this.inPayment == true) {
        classes += " panel-unavailable";
      }
      return classes;
    },
    
    
    
  },
  methods: {
    
    toNext: function() {
      console.log('in pay to next')
      if(this.AutoStartOver){this.startOver();}
      else{
        var nextPanelIndex = Number(this.panelIndex) + 1;
        this.$store.dispatch('setActivePanel',nextPanelIndex);
        this.panels[2].available = false;
        this.panels[1].available = false;
        this.panels[0].available = false;
      }
      
    },
    startOver: function() {
      this.getsuspendedticketcount()
      this.$store.dispatch('startOver');

    },
    
    popOptions(){
      this.openReceiptOptions(null,this.ticket)
    }
  },
  mounted: function() {
    //this.onInit();
  }
};
</script>
<style scoped>
.drawerfont{
  font:'control';
}
.payitemavailable {
  grid-area: payavailable;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height:100px;
}
.payitemadded {
  grid-area: payadded;
  display: flex;
  flex-direction: column;
  border-left: 1px solid gray;
  padding-left:20px;
  margin-left:10px;
  text-align:right;
  align-items: right;
}

.payfull {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto 80px;
  grid-template-areas:
    "payavailable payadded"
    "next next";
  padding: 20px;
}
.allpmt{
  border-top:1px solid gray;
  width:100%;
  text-align: left;
}
.openareabuttons{
  grid-area: open;
  padding-top:20px;
  text-align: left;
}
.narrowbutton{
  width:100px;
}
.receiptclass{
  margin-top:120px;
  white-space: pre-wrap;

} 
</style>